WiseMetering.Views.IndexSiteDocuments = WiseMetering.Views.TableIndex.extend({
    icon: 'document',

    createTable: function() {
        const collection = this.model.siteDocuments();

        this.table = new WiseMetering.Views.Table({
            id: 'site_documents',
            collection,
            columns: {
                name: i18next.t('common.name'),
                description: i18next.t('common.description'),
                created_by: i18next.t('glossary.created_by'),
                created_at: i18next.t('glossary.created_at'),
                fileExtension: i18next.t('common.file'),
                fileSize: i18next.t('integrations.file_size')
            },

            modelSerializer: function(model) {
                return {
                    id: model.id,
                    name: model.get('name'),
                    description: model.get('description'),
                    created_by: model.get('creator_name'),
                    created_at: WiseMetering.utils.formatDate(model.get('created_at')),
                    fileExtension: model.get('original_filename'),
                    fileSize: model.get('file_size_human')
                };
            },
            toolbar_actions: {
                new: {
                    view_call: () => new WiseMetering.Views.NewSiteDocument({
                        collection: WiseMetering.siteDocuments,
                        model: new WiseMetering.Model.SiteDocument({ site_id: this.model.get('site_id') })
                    })
                },
                edit: {
                    label: i18next.t('ui.actions.edit'),
                    view_call: model => new WiseMetering.Views.EditSiteDocument({ model })
                },
                delete: {
                    permission: 'administrator',
                    view_call: model => new WiseMetering.Views.Modal.Destroy({
                        model,
                        title: () => i18next.t('modal.title.site_documents.destroy')
                    })
                },
                show: {
                    view_call: model => new WiseMetering.Views.SiteDocumentModalShow({ model })
                }
            }
        });

        $(this.body.el).html(this.table.el);
    },

    onClose: function() {
        this.table.remove();
        this.stopListening(WiseMetering.siteDocuments);
    },

    onShow: function() {
        this.listenTo(WiseMetering.siteDocuments, 'add change remove', this.createTable.bind(this));
        this.createTable();
    }
});
